import { ColumnsType } from "antd/lib/table";
import { RelatorioLancamentoFinanceiroPorMesModel } from "../../../../../models/relatorio/relatorioLancamentoFinanceiroPorMesModel";
import { setModalRelatorioLancamentoFinanceiro } from "../../../../../redux/slices/relatorio/relatorioSlice";
import { buscarRelatorioLancamentoFinanceiroPorMesDrill } from "../../../../../services/relatorioService";
import { useAppDispatch, useAppSelector } from "../../../../../util/hooks";
import { Flex } from "antd";
import TableComponent from "../../../../../components/table/tableComponent";
import { currencyBRL } from "../../../../../util/dinheiroBRAuxiliar";
import { BuscarRelatorioLancamentoFinanceiroPorMesDrillModel } from "../../../../../models/relatorio/buscarRelatorioLancamentoFinanceiroPorMesDrillModel";
import { toastWarning } from "../../../../../util/toast";
import { pivotData, PivotedData } from "./functions/pivotData";
import { sortAnoMes } from "./functions/sortAnoMes";

const RelatorioLancamentoComparativo = () => {
  //estados globais
  const relatorioState = useAppSelector((state) => state.relatorio);

  //hooks
  const dispatch = useAppDispatch();

  const goDetalhe = (value: PivotedData, ano: string) => {
    const filterValue = relatorioState.listLancamentoFinanceiroPorMes.find((item) => item.id === value.id);
    if (!filterValue) {
      toastWarning("Nenhum dado encontrado para o filtro selecionado");
      return;
    }
    let busca: BuscarRelatorioLancamentoFinanceiroPorMesDrillModel = {
      ...relatorioState.buscaLancamentoFinanceiro,
      idHierarquia: value.id,
      dataAnoMes: (value[ano] as { valor: number; dataAnoMes: Date }).dataAnoMes,
    };

    dispatch(buscarRelatorioLancamentoFinanceiroPorMesDrill(busca));
    dispatch(setModalRelatorioLancamentoFinanceiro(true));
  };

  const generateColumns = (data: RelatorioLancamentoFinanceiroPorMesModel[]): ColumnsType<PivotedData> => {
    const uniqueAnoMes = Array.from(new Set(data.map((item) => item.anoMes)));
    const sortedAnoMes = sortAnoMes(uniqueAnoMes);

    const columns: ColumnsType<PivotedData> = [
      {
        title: "DESCRIÇÃO",
        dataIndex: ["codigo", "denominacao", "nivel"],
        render: (_, record: PivotedData) => <div style={{ padding: `2px ${(record.nivel - 1) * 10}px` }}>{`${record.codigo} ${record.denominacao}`}</div>,
      },
      ...sortedAnoMes.map((anoMes) => ({
        title: anoMes.toUpperCase(),
        dataIndex: anoMes,
        align: "right" as const,
        width: 150,
        onCell: (record: any) => {
          return {
            onClick: (event: any) => {
              event.stopPropagation();
              goDetalhe(record, anoMes);
            },
          };
        },
        render: (value: { valor: number; id: number }) => (
          <p
            style={{
              color: value?.valor < 0 ? "red" : "blue",
              marginBottom: "0px",
              cursor: "pointer",
            }}
          >
            {currencyBRL(value?.valor ?? 0)}
          </p>
        ),
      })),
      {
        title: "MÉDIA",
        dataIndex: "valor",
        align: "right" as const,
        width: 200,
        render: (_, record: PivotedData) => {
          const values = sortedAnoMes.map((anoMes) => (record[anoMes] as { valor: number; dataAnoMes: Date })?.valor).filter((val) => val !== undefined && val !== null);
          const total = values.reduce((sum, val) => sum + val, 0);
          const average = values.length > 0 ? total / values.length : 0;
          return (
            <p
              style={{
                color: average < 0 ? "red" : "blue",
                marginBottom: "0px",
              }}
            >
              {currencyBRL(average)}
            </p>
          );
        },
      },
    ];

    return columns;
  };

  const pivotedData = pivotData(relatorioState.listLancamentoFinanceiroPorMes);
  const columns = generateColumns(relatorioState.listLancamentoFinanceiroPorMes);

  return (
    <Flex vertical>
      <TableComponent columns={columns} data={pivotedData} loading={relatorioState.loadingLancamentoFinanceiro} pagination={false} />
    </Flex>
  );
};

export default RelatorioLancamentoComparativo;
